'use client';
import { jsx } from 'react/jsx-runtime';
import { createContext, useId, useState } from 'react';

/**
 * PopoverTriggerContext component, use to wrap a Popover.Trigger and Popover.
 *
 * @example
 * <PopoverTriggerContext>
 *   <PopoverTrigger>Open Popover</PopoverTrigger>
 *   <Popover>
 *     Content
 *   </Popover>
 * </PopoverTriggerContext>
 */
const PopoverTriggerContext = ({ children, }) => {
    const randomPopoverId = useId();
    const [popoverId, setPopoverId] = useState(randomPopoverId);
    return (jsx(Context.Provider, { value: { popoverId, setPopoverId }, children: children }));
};
PopoverTriggerContext.displayName = 'PopoverTriggerContext';
const Context = createContext({});

export { Context, PopoverTriggerContext };
